import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_THEME } from "../theme/theme";

const tabs = [
  {
    label: "Home",
    path: "/home",
    icon: (color, active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? color : "none"} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    label: "Margin",
    path: "/margin",
    icon: (color, active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? color : "none"} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" stroke={active ? APP_THEME.bgColor : color} />
        <circle cx="9.5" cy="9.5" r="1.5" fill={active ? APP_THEME.bgColor : color} stroke="none" />
        <circle cx="14.5" cy="14.5" r="1.5" fill={active ? APP_THEME.bgColor : color} stroke="none" />
        {active && <circle cx="12" cy="12" r="10" fill={color} style={{ zIndex: -1 }} />}
        {active && (
          <>
            <line x1="15" y1="9" x2="9" y2="15" stroke={APP_THEME.bgColor} strokeWidth="2" />
            <circle cx="9.5" cy="9.5" r="1.5" fill={APP_THEME.bgColor} stroke="none" />
            <circle cx="14.5" cy="14.5" r="1.5" fill={APP_THEME.bgColor} stroke="none" />
          </>
        )}
      </svg>
    ),
  },
  {
    label: "History",
    path: "/history",
    icon: (color, active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? color : "none"} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
        {active && <circle cx="12" cy="12" r="10" fill={color} />}
        {active && <polyline points="12 6 12 12 16 14" stroke={APP_THEME.bgColor} strokeWidth="2.5" />}
      </svg>
    ),
  },
  {
    label: "Profile",
    path: "/profile",
    icon: (color, active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? color : "none"} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "64px",
        background: APP_THEME.bgColor,
        borderTop: `1px solid ${APP_THEME.borderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        zIndex: 900,
        maxWidth: "100%",
        margin: "0 auto",
      }}
    >
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        const color = isActive ? APP_THEME.primaryColor : APP_THEME.textSecondary;

        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              background: "none",
              border: "none",
              padding: "6px 0",
              flex: 1,
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
          >
            {tab.icon(color, isActive)}
            <span
              style={{
                fontSize: "11px",
                color: color,
                fontFamily: APP_THEME.fontFamily,
                fontWeight: isActive ? 700 : 500,
                transition: "color 0.2s ease",
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNav;
